import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { getUserInfo } from "@/apis/user";
import Layout from "@/components/Layout";
import AlertModal from "@/components/Modal/AlertModal";
import Tab from "@/components/Tab";
import { HOME_MAIN_URL } from "@/constants/routes";
import useModal from "@/hooks/useModal";
import LogManagement from "@/pages/Admin/components/LogManagement";
import OrgManagement from "@/pages/Admin/components/OrgManagement";
import ParkingInfo from "@/pages/Admin/components/ParkingInfo";
import PlaceManagement from "@/pages/Admin/components/PlaceManagement";
import ReservationInfo from "@/pages/Admin/components/ReservationInfo";
import UserInfo from "@/pages/Admin/components/UserInfo";
import VehicleReservationAdmin from "@/pages/Admin/components/VehicleReservationAdmin";
import useLoginStore from "@/store/loginStore";
import useUserStore from "@/store/userStore";

const hasPermission = (permissions: string | undefined, perm: string) =>
  (permissions || "").split(",").map(s => s.trim()).includes(perm);

const Admin = () => {
  const alertModal = useModal();
  const navigate = useNavigate();
  const user = useUserStore();
  const loginInfo = useLoginStore();
  const [alertMessage] = useState("관리자 외에 접근이 불가합니다.");

  const isAdmin = user.roleId === "ADMIN";
  const canParking = isAdmin || hasPermission(user.permissions, "parking");

  useEffect(() => {
    checkRole();
  }, []);

  const checkRole = async () => {
    // 1차 확인: ADMIN 또는 특정 권한 보유자 허용
    const hasAnyPermission = isAdmin || hasPermission(user.permissions, "parking");
    if (!hasAnyPermission) {
      alertModal.onOpen();
      navigate(HOME_MAIN_URL);
      return;
    }
    // 2차 확인 (서버 검증)
    const res = await getUserInfo(loginInfo.tokenId);
    const serverHasAccess = res.roleId === "ADMIN" || hasPermission(res.permissions, "parking");
    if (!serverHasAccess) {
      alertModal.onOpen();
      navigate(HOME_MAIN_URL);
    }
  };
  
  return (
    <>
      <Layout>
        <div className="flex flex-col gap-4">
          <Tab variant="enclosed">
            {isAdmin && (
              <Tab.Item label="회원정보 관리" className="relative">
                <UserInfo />
              </Tab.Item>
            )}
            {isAdmin && (
              <Tab.Item label="장소예약 관리" className="relative">
                <ReservationInfo />
              </Tab.Item>
            )}
            {isAdmin && (
              <Tab.Item label="차량예약 관리" className="relative">
                <VehicleReservationAdmin />
              </Tab.Item>
            )}
            {isAdmin && (
              <Tab.Item label="장소 관리" className="relative">
                <PlaceManagement />
              </Tab.Item>
            )}
            {isAdmin && (
              <Tab.Item label="조직 관리" className="relative">
                <OrgManagement />
              </Tab.Item>
            )}
            {canParking && (
              <Tab.Item label="주차정보 관리" className="relative">
                <ParkingInfo />
              </Tab.Item>
            )}
            {isAdmin && (
              <Tab.Item label="로그 관리" className="relative">
                <LogManagement />
              </Tab.Item>
            )}
          </Tab>
        </div>
      </Layout>
      {alertModal.isOpen && (
        <AlertModal onClose={alertModal.onClose}>{alertMessage}</AlertModal>
      )}
    </>
  );
};

export default Admin;
